import { environment } from '../../../../../../environments/environment';
import { SUPERMERCADOS_CODE } from '../../../../../core/configs/company.config';
const session = JSON.parse(localStorage.getItem(environment.sessionAuth));
const validatebyCompany= { 
  validateDivision: () => {
    return session && session.user.entity.company.code === SUPERMERCADOS_CODE ? "Área" : "División"
  },
  validateArea: () => {
    return session && session.user.entity.company.code === SUPERMERCADOS_CODE ? "Sección" : "Departamento"
  }
}
export const reportContainer = {
  searchText: "",
  addText: "",
  checkbox: false,
  expandable: false,
  paginator: true,
  disabled: false,
  export: true,
  exportAllData: true,
  exportFile: 'reporte_de_contenedores.xlsx',
  partialField: "",
  showIcon: "./assets/icon/ico_placeholder_documentos.svg",
  columns: [
    {
      title: "Cod. Contenedor",
      name: "containerCode",
      type: "string",
      checkAll: false,
      editable: false,
      class: "text-center",
      value: (element: any) => element.containerCode,
    },
    {
      title: "Entidad",
      name: "entity",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.entity,
    },
    {
      title: "SKU",
      name: "productSku",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.productSku,
    },
    {
      title: "Descripción",
      name: "productDescription",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.productDescription,
    },
    {
      title: "Marca",
      name: "productTradeMark",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: any) => element.productTradeMark,
    },
    {
      title: "Estado",
      name: "stateOrderName",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.stateOrderName,
    },
    {
      title: "Nota de venta",
      name: "orderNumber",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.orderNumber,
    },
    {
      title: "N° de despacho",
      name: "serialNumber",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.serialNumber,
    },
    {
      title: "Cantidad solicitada",
      name: "sAmountRequested",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.sAmountRequested,
    },
    {
      title: "Cantidad atendida",
      name: "sAmountAttended",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.sAmountAttended,
    },
    {
      title: "Cantidad consolidada",
      name: "sAmountConsolidated",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.sAmountConsolidated,
    },
    {
      title: "Cantidad cancelada",
      name: "sAmountCancelled",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.sAmountCancelled,
    },
    {
      title: validatebyCompany.validateDivision(),
      name: "division",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => session.user.entity.company.code === SUPERMERCADOS_CODE ? element.area : element.division,
    },
    {
      title: validatebyCompany.validateArea(),
      name: "department",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => session.user.entity.company.code === SUPERMERCADOS_CODE ? element.section : element.department,
    },
    {
      title: "Fecha y hora de creación",
      name: "dateCreated",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.dateCreated,
    },
    {
      title: "Fecha de despacho",
      name: "dateDispatch",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.dateDispatch,
    },
    {
      title: "Tipo de despacho",
      name: "methodDeliveryName",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.methodDeliveryName,
    },
    {
      title: "Estado de despacho",
      name: "stateOrderDispatchName",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.stateOrderDispatchName,
    },
    {
      title: "Usuario picking",
      name: "username",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.username,
    },
    {
      title: "Motivo",
      name: "reasonDescription",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.reasonDescription,
    },
    {
      title: "Ecommerce ID",
      name: "ecommerceId",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.ecommerceId,
    },
    {
      title: "Etiqueta/Jaba",
      name: "lpn",
      type: "string",
      checkAll: false,
      editable: false,
      class: "text-center",
      value: (element: any) => session.user.entity.company.code === SUPERMERCADOS_CODE ? element.containerCode : element.lpn,
    },
    {
      title: "Inicio de Ventana Horaria",
      name: "startDateDeliveryWindow",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.startDateDeliveryWindow,
    },
    {
      title: "Fin de Ventana Horaria",
      name: "endDateDeliveryWindow",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.endDateDeliveryWindow,
    },
    {
      title: "Ubicación",
      name: "location",
      type: "string",
      editable: false,
      checkAll: false,
      value: (element: any) => element.location,
    },
  ],
};
